<template>
  <div class="promo-page">
    <Promo />
  </div>
</template>

<script>
import { Promo } from '@/features/promo';

export default {
  components: { Promo },
};
</script>

<style lang="scss" scoped>
.promo-page {
  margin-top: 0 !important;
  overflow: hidden;
}
</style>
